import React from 'react';
import { useParams } from "react-router-dom";
import styled from 'styled-components';


/** Composants */
import Logo from '../components/Logo.js'
import NavBar from '../components/NavBar.js'
import Footer from '../components/Footer.js'
import ElementAdd from '../components/ElementAdd.js'


const Page = styled.div`
position:relative;
min-height:100vh;
padding-bottom:300px;
overflow-y: scroll;
`

const Titre = styled.h2`
margin:0 auto;
`

const PageAdd = () => {
    const {typeElement} = useParams()

    return (
        <Page>
            <Logo/>
            <NavBar/>
            <Titre>{typeElement}</Titre>
            <ElementAdd typeElement={typeElement} />
            <Footer/>
        </Page>
    )
}
export default PageAdd
